import { cx } from 'class-variance-authority';

import { Text } from '@nvision/ui';

import { ReactComponent as NoDataIcon } from './no-data-icon.svg';

import styles from './no-data.module.css';

interface NoDataProps {
  description: string;
  className?: string;
}

export const NoData: React.FC<NoDataProps> = ({ description, className }) => {
  return (
    <div className={cx(styles.container, className)}>
      <NoDataIcon />
      <Text>{description}</Text>
    </div>
  );
};
